import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback } from "react";
import { Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
export const CloseButton = React.memo((props) => {
    const { t } = useTranslation("components");
    const onClick = props.onClick;
    const onClickHandler = useCallback(() => {
        onClick();
    }, [onClick]);
    return (_jsx(IconButton, { onClick: onClickHandler, type: "button", disableRipple: true, disableFocusRipple: true, disableTouchRipple: true, className: props.className, disabled: props.disabled, "aria-label": t("buttonLabels.close"), sx: {
            padding: 0,
            margin: 0,
        }, children: _jsx(Close, { style: { color: "var(--gray-500)", fontSize: 20 } }) }));
});
//# sourceMappingURL=CloseButton.js.map